import { render, staticRenderFns } from "./aboutHeader.vue?vue&type=template&id=087e29e2&scoped=true&"
import script from "./aboutHeader.vue?vue&type=script&lang=js&"
export * from "./aboutHeader.vue?vue&type=script&lang=js&"
import style0 from "./aboutHeader.vue?vue&type=style&index=0&id=087e29e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e29e2",
  null
  
)

export default component.exports